import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import searchLogo from "../../assets/search.svg";
import { setSearch } from "../../features/filters/filterSlice";

const Search = () => {
    const dispatch = useDispatch();
    const {search} = useSelector(state => state.filters)
    const [searchKey, setSearchKey] = useState(search)

    const handleSearchSubmit = (e) => {
        e.preventDefault();

        dispatch(setSearch(searchKey))
    }

	return (
		<form onSubmit={handleSearchSubmit} className="border border-slate-300 overflow-hidden flex items-center bg-white h-10 px-2 md:px-5 ring-emerald-200 w-fit rounded-md">
			<input
				type="search"
				name="search"
                value={searchKey}
                onChange={e => setSearchKey(e.target.value)}
				autoComplete="off"
				placeholder="Search..."
				className="border-none outline-none md:mr-2 focus:border-none focus:outline-none focus:ring-0"
			/>
			<img src={searchLogo} alt="" className="inline h-5 cursor-pointer" />
		</form>
	);
};

export default Search;
